import styled from "styled-components";
import { dangerColor, darkBlue } from "ui/colors";

export const FilterContainer = styled.div`
  display: flex;
`;

export const FilterInputContainer = styled.div`
  flex-basis: 45%;
`;

export const FilterInputsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const FilterInputsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-items: space-between;
`;

export const FilterDividerWrapper = styled.div`
  color: ${darkBlue};
  margin: 0 16px;
  font-size: 14px;
`;

export const FilterLabel = styled.div`
  font-size: 20px;
  align-self: center;

  max-width: calc(100% - 304px);
  width: 100%;
  color: ${darkBlue};
`;

export const ErrorMessageContainer = styled.div`
  color: ${dangerColor};
  margin-top: 6px;
  font-size: 14px;
  line-height: 16px;
`;
